import { useSelector } from 'react-redux'
import {
  IdentityCard,
  IdentityEmail,
  IdentityInfo,
  IdentityName,
  Photo,
  PhotoRing,
  ProfileRoot,
  RoleBadge,
  RoleList,
} from './UserProfile.styles'
import getLogger from '../../core/debuggers/logger.js'
import Spinner from '../../components/Spinners/Spinner.jsx'
import { getAvatarSrc, handleAvatarError } from '../../config/settings/avatar'

const logger = getLogger('UserProfile')

const UserProfile = () => {
  const { profile, status, error: profileError } = useSelector(
    state => state.adminUserProfile
  )
  const { roles } = useSelector(state => state.acl)

  logger.debug(profile)

  if (status.fetch === 'loading') return <Spinner />
  if (profileError !== null) return <p>Error: {profileError}</p>
  if (!profile) {
    return (
      <p>
        No pudimos cargar esta información, vuelve a intentarlo en unos minutos.
      </p>
    )
  }

  return (
    <ProfileRoot>
      <IdentityCard>
        <PhotoRing>
          <Photo
            src={getAvatarSrc(profile?.avatarUrl)}
            alt={profile?.fullName}
            referrerPolicy="no-referrer"
            onError={handleAvatarError}
          />
        </PhotoRing>
        <IdentityInfo>
          <IdentityName>{profile?.fullName}</IdentityName>
          <IdentityEmail>{profile.email}</IdentityEmail>
          <RoleList>
            {roles?.length
              ? roles.map(role => <RoleBadge key={role}>{role}</RoleBadge>)
              : null}
          </RoleList>
        </IdentityInfo>
      </IdentityCard>
    </ProfileRoot>
  )
}

export default UserProfile
